"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumerClient = void 0;
const tslib_1 = require("tslib");
exports.consumerClient = tslib_1.__importStar(require("./client.gen"));
tslib_1.__exportStar(require("./types.gen"), exports);
